import { render, staticRenderFns } from "./D204.vue?vue&type=template&id=ae17a70a&scoped=true"
import script from "./D204.vue?vue&type=script&lang=js"
export * from "./D204.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Pdis.css?vue&type=style&index=0&id=ae17a70a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae17a70a",
  null
  
)

export default component.exports